<template>
    <div class="wrapper">
        <b-container>
            <mini-nav class="mt-4"></mini-nav>
            <b-row>
                <div class="detail" v-html="content"></div>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import miniNav from '@/views/about/miniNav/miniNav.vue';

export default {
    components:{ miniNav },
    data(){
        return{
            content:'',
        }
    },
     created(){
        this.getAboutList()
    },
    methods:{
        getAboutList(){
            this.$api.aboutList()
            .then(res=>{
                console.log(res.data.futureConstitution)
                this.content = res.data.futureConstitution
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.detail::v-deep{
    p{
        line-height: 32px;
        transform: scale(0.88) !important;  
    }
}
 
</style>